export default "__VITE_ASSET__BezBd2Vy__"